<template>

	<div class="loader" v-if="loading">
		<h3>
			<b-spinner class="mr-4" />
			<span class="label">Please wait...</span>
		</h3>
	</div>

</template>

<script>

	export default {
		props: {
			loading: Boolean
		}
	}

</script>

<style scoped>

	.loader {
		position: fixed;
		z-index: 999;
		top: 0;
		left: 0;
		height: 100vh;
		width: 100vw;
		background-color: rgba(0,0,0,0.8);
		display: flex;
		text-align: center;
	}

	.loader h3 {
		width: 100%;
		height: 60px;
		margin: 0 auto;
		align-self: center;
		justify-self: center;
		text-align: center;
		color: #fff;
		font-size: 30px;
	}

	.loader h3 .label {
		vertical-align: text-bottom;
		line-height: 30px;
	}

</style>
